// GoHighLevel / LeadConnector external tracking.
//
// Both IDs below are PUBLIC: the tracking script ships them to every visitor in
// the page source, and the events endpoint is unauthenticated by design. They
// are hardcoded rather than env-gated for the same reason the chat widget ID is
// (components/analytics/leadconnector-widget.tsx) — a forgotten Vercel variable
// would silently stop lead capture, and nobody notices missing leads until the
// pipeline looks empty.
//
// The sub-account API KEY is a different animal: it is a secret, it is NOT in
// this repo, and it must never reach client code. It is only needed for admin
// calls (listing/creating custom fields) — run those from a shell with the key
// in an env var, never from the app.
export const GHL_TRACKING_ID = "tk_92722a85dc6041efa6c8735e4d96359b";
export const GHL_LOCATION_ID = "HQTof2BczR0mhPQFMLPK";

export const GHL_TRACKING_SRC = "https://link.msgsndr.com/js/external-tracking.js";
export const GHL_EVENTS_ENDPOINT =
  "https://backend.leadconnectorhq.com/external-tracking/events";

// Custom-field keys must match the fields that actually exist on the location,
// or GHL silently drops the value. Verified against
// GET /locations/<id>/customFields on 2026-08-18:
//   contact.contact_form_message -> "Contact Form Message" (LARGE_TEXT)
// first_name / last_name / email / phone are BUILT-IN contact fields and
// deliberately carry no `contact.` prefix.
export const GHL_FIELD_MESSAGE = "contact.contact_form_message";

// Form name shown in GHL reporting. Used BOTH as `data-formid` on the <form>
// (which the tracking script reads for its own automatic event) and as
// `formId` in our explicit event, so one submission never appears under two
// different names.
export const GHL_CONTACT_FORM_ID = "Website Contact Form";
